import { useFocusVisible as useFocusVisibleComponent } from './use-focus';
import { FocusVisibleManager as FocusVisibleManagerComponent } from './focus-provider';

export const useFocusVisible = useFocusVisibleComponent;
export const FocusVisibleManager = FocusVisibleManagerComponent;
